export const DASHBOARD_REDIRECT_EXCLUSION = [
    '/specialofferdetail',
    "/quotation",
    '/adminspecialoffers',
    '/onboarding',
    '/creditteam',
    '/createcreditrequest',
    '/shiptoparty',
    "/achivements",
    "/specialpricerequest",
    "/myschedule",
    "/quotation"
]
